export const MenuData = [
    {
        title:'Painel',
        url:"/admin",
        cName :"active top",
        icone:"fa-solid fa-home"
    },

      {
        title:'Posts',
        url:"/admin",
        cName :"nav-links",
        icone:"bx bxs-shopping-bag-alt"
    },
    {
        title:'Recettes',
        url:"/listarRecettes/",
        cName :"nav-links",
        icone:"fa-solid fa-bowl-food"
        
    },
    {
        title: "Usuarios ",
        url: "/usuarios/",
        cName : 'nav-links',
        icone:"bx bxs-group"
    },
    {
        title: "Messages",
        url: "/messages",
        cName : 'nav-links',
        icone:"bx bxs-message-dots"
    },
      {
        title: "Cardapio",
        url: "admin/cardapio",
        cName : 'nav-links',
        icone:"fa-solid fa-utensils"
    },

   
/*
    {
        title: "Login",
        url: "./login",
        cName : 'nav-links',
        icone : "fa-solid fa-user"
    },*/
    
]

